import { VariantFamily } from './variant-family';

export interface VariantOption {
    id: number;
    description: string;
    value: string;
    variantFamilyId: number;
    variantFamily: VariantFamily;
}
